import React, { useState } from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        company: '',
        service: '',
        message: ''
      });
    }, 3000);
  };

  return (
    <section className="contact" id="contact" aria-labelledby="contact-title">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Get In Touch</span>
          <h2 className="section-title" id="contact-title">
            Let's Start Your <span className="gradient-text">Success Story</span>
          </h2>
          <p className="section-description">
            Ready to transform your business? Get in touch with us today for a free consultation
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Why Choose IdeasPoint?</h3>
            <p>
              We're committed to delivering exceptional results that exceed your expectations. 
              Our team of experts is ready to help you achieve your business goals.
            </p>

            <address className="contact-details">
              <div className="contact-detail">
                <div className="detail-icon" aria-hidden="true">
                  <FaEnvelope />
                </div>
                <div className="detail-content">
                  <h4>Email Us</h4>
                  <p><a href="mailto:projects.ideaspoint@gmail.com">projects.ideaspoint@gmail.com</a></p>
                </div>
              </div>

              <div className="contact-detail">
                <div className="detail-icon" aria-hidden="true">
                  <FaPhone />
                </div>
                <div className="detail-content">
                  <h4>Call Us</h4>
                  <p><a href="tel:+919867553336">+91 9867553336</a></p>
                </div>
              </div>

              <div className="contact-detail">
                <div className="detail-icon" aria-hidden="true">
                  <FaMapMarkerAlt />
                </div>
                <div className="detail-content">
                  <h4>Visit Us</h4>
                  <p>Global Operations</p>
                </div>
              </div>
            </address>

            <div className="response-time">
              <div className="response-badge">
                <span className="pulse"></span>
                We typically respond within 24 hours
              </div>
            </div>
          </div>

          <div className="contact-form-wrapper">
            {submitted ? (
              <div className="success-message" role="alert" aria-live="polite">
                <div className="success-icon" aria-hidden="true">✓</div>
                <h3>Thank You!</h3>
                <p>We've received your message and will get back to you shortly.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit} noValidate>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Your Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="John Doe"
                      required
                      aria-required="true"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="john@company.com"
                      required
                      aria-required="true"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="company">Company Name</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Your Company"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="service">Service Interested In *</label>
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                      aria-required="true"
                    >
                      <option value="">Select a service</option>
                      <option value="web-development">Web Development</option>
                      <option value="digital-marketing">Digital Marketing</option>
                      <option value="brand-creation">Brand Creation</option>
                      <option value="business-consultation">Business Consultation</option>
                      <option value="data-analytics">Data Analytics</option>
                      <option value="design-creation">Design Creation</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Your Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us about your project..."
                    rows="5"
                    required
                    aria-required="true"
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary submit-btn" aria-label="Send message to IdeasPoint">
                  Send Message <FaPaperPlane aria-hidden="true" />
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
